import { Primitive } from "./types";

export const buildUri = (
    uri: string,
    params: Record<string, Primitive> = {},
    query: Record<string, Primitive> = {}
) => {
    if (Object.entries(params).length !== 0 && params.constructor === Object) {
        let regex = /(:)([a-z]*)/gi,
            result = [];
        while ((result = regex.exec(uri))) {
            if (params[result[2]] != null) uri = uri.replace(result[0], `${params[result[2]]}`);
        }
    }
    if (Object.entries(query).length !== 0 && query.constructor === Object) {
        uri = uri.indexOf("?") !== -1 ? uri.concat("&") : uri.concat("?");
        Object.keys(query).forEach(q => {
            if (query[q] != null) uri = `${uri}${q}=${query[q]}&`;
        });
        uri = uri.substring(0, uri.length - 1);
    }
    return uri;
};
